import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import MangaCard from "@/components/base/MangaCard";

export default function RankFeature() {
  const top5 = [...mangaList].sort((a, b) => a.popular - b.popular).slice(0, 5);
  const editors = mangaList.filter((m) => ["star-rail", "cloud-cafe", "flower-lane", "mountain-cat"].includes(m.id));

  return (
    <section className="bg-background-50 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
          {/* 排行榜 */}
          <div>
            <div className="flex items-end justify-between">
              <div>
                <p className="text-xs font-bold tracking-wide text-primary-600">TOP RANK</p>
                <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">本周热门排行榜</h2>
              </div>
              <Link to="/rank" className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
                全部榜单 <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              </Link>
            </div>

            <ol className="mt-6 space-y-3">
              {top5.map((manga, idx) => (
                <li key={manga.id}>
                  <Link
                    to="/rank"
                    className="group flex items-center gap-4 rounded-2xl bg-background-100 p-3 transition-colors hover:bg-background-200"
                  >
                    <span
                      className={`flex h-10 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg ${
                        idx === 0 ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-800"
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <img
                      src={manga.cover}
                      alt={`${manga.title}漫画封面`}
                      className="h-16 w-12 shrink-0 rounded-lg object-cover object-top"
                    />
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                        {manga.title}
                      </h3>
                      <p className="mt-0.5 text-xs text-foreground-600">{manga.genre} · {manga.status}</p>
                    </div>
                    <span className="flex items-center gap-0.5 text-sm font-bold text-accent-600">
                      <i className="ri-star-fill text-xs text-accent-500" aria-hidden="true"></i>
                      {manga.rating}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          {/* 编辑推荐 */}
          <div>
            <div className="flex items-end justify-between">
              <div>
                <p className="text-xs font-bold tracking-wide text-accent-600">EDITOR PICK</p>
                <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">编辑部本周力荐</h2>
              </div>
              <Link to="/recommend" className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700">
                更多推荐 <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              </Link>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-4">
              {editors.map((manga) => (
                <MangaCard key={manga.id} manga={manga} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}